import InfoIcon from "@mui/icons-material/Info";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { grey } from "@mui/material/colors";

import CallPatientNumberButton from "components/suno-dialer/call-patient/call-patient-number-button.component";
import { type Patient } from "services/types/patients.type";
import { formatPhoneNumber } from "utils/common";

type PhoneContactProps = {
  title: string;
  phoneNumber: string;
  notes?: string | null;
  patient?: Patient;
};
export default function PhoneContact({
  title,
  phoneNumber,
  notes,
  patient
}: PhoneContactProps) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-end"
      mt={0.25}
    >
      <Stack>
        <Typography
          sx={{
            fontSize: "13px",
            lineHeight: 1,
            color: grey[600],
            mb: 0.25
          }}
        >
          {title}{" "}
          {notes && (
            <Tooltip title={notes}>
              <InfoIcon
                sx={{ fontSize: "17px", transform: "translateY(3px)" }}
              />
            </Tooltip>
          )}
        </Typography>

        <Typography
          sx={{
            fontSize: "15px",
            lineHeight: 1.1,
            mb: 0.2
          }}
        >
          {formatPhoneNumber(phoneNumber ?? "")}
        </Typography>
      </Stack>

      <CallPatientNumberButton
        title={title}
        phoneNumber={phoneNumber}
        patient={patient}
      />
    </Stack>
  );
}
